import {FETCH_BASKET_VOUCHERS} from 'services/campaign/constants/queries';
import {BasketVoucherDetails, FetchBasketVouchersQuery} from 'types/campaign';
import {campaignApolloClientWithToken} from 'utils';

export const fetchBasketVouchers = async (idToken: string, query: FetchBasketVouchersQuery) => {
  const campaignApolloClient = campaignApolloClientWithToken(idToken);
  const response = await campaignApolloClient.query({
    query: FETCH_BASKET_VOUCHERS,
    variables: query
  });
  return response.data.fetchBasketVouchers as BasketVoucherDetails;
};
